<template>
    <section class="text-center pt-12">
        <BackButton :to="{ name: 'beret-prepare' }" />
        <Title>Béret</Title>
        <div class="space-y-8">
            <div class="bg-gray-500 p-5 rounded-lg text-4xl">
                <p class="text-sm mb-3">J'appelle les numéros</p>
                <transition-group tag="div" name="slide" class="relative flex items-end h-16" >
                    <span :key="`round-${PreviousRound.id}`" class="round round-previous text-base">{{PreviousRound.round}}</span>
                    <span :key="`round-${CurrentRound.id}`" class="round round-current font-semibold col-span-3">{{CurrentRound.round}}</span>
                    <span :key="`round-${NextRound.id}`" class="round round-next text-base">{{NextRound.round}}</span>
                </transition-group>
            </div>
            <div class="mb-auto">
                <button class="bg-gradient-to-r from-violet-300 to-violet-400 text-white text-4xl font-bold py-6 rounded w-full"
                    @click="Salade">
                    Salade
                </button>
            </div>
            <div class="w-full grid grid-cols-6">
                <div class="p-8 col-span-2 font-semibold text-6xl">{{Scores.Red}}</div>
                <div class="p-8 col-span-2 font-semibold text-5xl">-</div>
                <div class="p-8 col-span-2 font-semibold text-6xl">{{Scores.Blue}}</div>
                <button class="col-span-2 h-32 rounded bg-red-400" @click="GivePoint('Red')"></button>
                <div class="col-span-2"></div>
                <button class="col-span-2 h-32 rounded bg-blue-400" @click="GivePoint('Blue')"></button>
            </div>
            <button class="w-full bg-gray-600 p-4 rounded-lg" @click="Undo">Undo</button>
        </div>
    </section>
</template>
<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
export default {
    computed: {
        ...mapState('Beret', ['RoundNumber']),
        ...mapGetters('Beret', ['PreviousRound', 'CurrentRound', 'NextRound', 'Scores'])
    },
    methods: {
        ...mapActions('Beret', ['GivePoint', 'Undo', 'Salade'])
    },
    beforeRouteEnter: (to, from, next) => {
        next(vm => {
            if (!vm.$store.state.Beret.Rounds || !vm.$store.state.Beret.Rounds.length) {
                next({ name: 'beret-prepare' })
            }
        })
    }
}
</script>
<style scoped>
.round {
    transition: all 2s;
    position: absolute;
    bottom: 0;
}

.round-previous {
    left: 0
}

.round-current {
    transform:translateX(-50%);
    left: 50%;
}

.round-next {
    right: 0
}

.slide-leave-active {
    position: absolute;
}

.round-previous.slide-enter, .round-previous.slide-leave-to {
    opacity: 0;
    transform: translateX(-100%);
}

.round-next.slide-leave-to, .round-next.slide-enter {
    opacity: 0;
    transform: translateX(100%);
}

.round-current.slide-enter {
    opacity: 0;
    transform: translateY(100%);
}
</style>